import { useEffect } from 'react'
import { useSignal } from '@preact/signals-react'
import { useAppToast } from '@ui-seeker/app'
import { postSubmit } from '@ui-seeker/utils'

import { BACKEND_APIS } from '@constants'
import { skuGroupDrawerFilters, reloadSkuGroupFilters } from '../../@signals'

const MODE_LABELS = {
    create: 'Create SKU Group',
    edit: 'Edit SKU Group',
}

export default function useSkuGroupDrawerForm() {
    const { showToast } = useAppToast()

    const name = useSignal('')
    const skuIDs = useSignal([])
    const userIDs = useSignal([])
    const brandFilter = useSignal([])
    const customerFilter = useSignal(null)

    useEffect(() => {
        const drawer = skuGroupDrawerFilters.value
        if (!drawer.mode) return

        name.value = drawer.name || ''
        brandFilter.value = []
        if (drawer.mode === 'create') {
            skuIDs.value = []
            userIDs.value = []
            customerFilter.value = null
        } else {
            skuIDs.value = drawer.skuIDs || []
            customerFilter.value = drawer.customerID
        }
    }, [skuGroupDrawerFilters.value])

    const handleSubmit = () => {
        const drawer = skuGroupDrawerFilters.value
        const url = drawer.mode === 'create'
            ? `${BACKEND_APIS.MANAGEMENT}/sku-group/create`
            : `${BACKEND_APIS.MANAGEMENT}/sku-group/update`
        const payload = {
            skuGroupID: drawer.skuGroupID,
            customerID: customerFilter.value,
            name: name.value,
            skuIDs: skuIDs.value,
            ...(drawer.mode === 'create' && { userIDs: userIDs.value }),
        }
        showToast.promise(
            postSubmit(url, payload).then(() => {
                reloadSkuGroupFilters.value += 1
                skuGroupDrawerFilters.value = {}
            })
        )
    }

    return {
        name,
        skuIDs,
        userIDs,
        brandFilter,
        customerFilter,
        handleSubmit,
        drawerTitle: MODE_LABELS[skuGroupDrawerFilters.value?.mode] || '',
    }
}
